import MomentUtils from '@date-io/moment'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { Provider } from 'mobx-react'
import moment from 'moment'
import 'moment/locale/ky'
import 'moment/locale/ru'
import 'moment/locale/uz-latn'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { getMomentLocale, i18n, initialize, useTranslation } from '../common'
import stores from '../stores/stores'
import App from './components/App'
import { AppHelmet } from './components/Helmet'
import reportWebVitals from './reportWebVitals'
import './styles/main.scss'
import { tokenStorage } from './utils'
import './gtag'

const syncMomentLocale = language => moment.locale(getMomentLocale(language))

// Keep date formatting aligned with the language selected in the navigation.
i18n.on('languageChanged', syncMomentLocale)
syncMomentLocale(i18n.resolvedLanguage || i18n.language)
const store = stores()
store.appState.useTokenStorage(tokenStorage)
initialize(store.appState)

function Web() {
  const {
    i18n: { language },
  } = useTranslation()
  syncMomentLocale(language)

  return (
    <>
      <AppHelmet />
      <MuiPickersUtilsProvider
        utils={MomentUtils}
        locale={getMomentLocale(language)}
      >
        <Provider store={store}>
          <Router>
            <App />
          </Router>
        </Provider>
      </MuiPickersUtilsProvider>
    </>
  )
}

createRoot(document.getElementById('root')).render(<Web />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
